<div class="row">
    <div class="col-md-12 pt-3">
        <div class="row">
            <div class="col-md-3 select-activity-pack-title">
                <h3 class="mb-0">Select Project Types</h3>
            </div>
            <div class="col-md-9 d-flex justify-content-end align-items-center">
                <app-instance-info-section></app-instance-info-section>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 d-flex justify-content-end align-items-center">
                <button type="button" class="btn primary-ebtn me-3" onclick="" (click)="createProjectTypes()">Create Project Type</button>
            </div>
        </div>
    </div>
    <div class="content-wrapper col-md-12">
        <div class="row" style="width: 100%; margin: 10px 0px">
            <ng-container *ngIf="defaultProjectTypesList && defaultProjectTypesList.length > 0">
                <div class="col-md-2 col-md-3 mt-4 mb-4 files-card-view" *ngFor="let type of defaultProjectTypesList; let i = index">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card_gridFour">
                                <div class="col-md-12">
                                    <div class="row">
                                        <div class="col-md-12 card_grid_heading align-items-center justify-content-between">
                                            <div class="d-flex align-items-center justify-content-between py-2">
                                                <div class="d-flex align-items-center flex-row">
                                                    <div class="activity-checkbox">
                                                        <mat-checkbox
                                                            class="checkbox-wrap"
                                                            [checked]="type.isSelected"
                                                            (change)="checkUncheckActivityPackType($event, type)"
                                                        ></mat-checkbox>
                                                    </div>
                                                    <div class="card_grid_heading-right">
                                                        <h4 class="card_grid_heading_title px-3">{{ type.name }}</h4>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="gridleft_symbols d-flex align-items-center me-3">
                                                        <div class="eye-icon" (click)="viewProjectType(type)">
                                                            <!-- <i class="far fa-eye" matTooltip="View"></i> -->
                                                            <mat-icon
                                                                #tooltip="matTooltip"
                                                                matTooltip="View"
                                                                [matTooltipPosition]="tooltip_position"
                                                                class="mat-icon-view"
                                                            >
                                                                remove_red_eye
                                                            </mat-icon>
                                                        </div>
                                                        <div class="delete-icon">
                                                            <!-- <i class="far fa-trash-alt"
                                                                (click)="deleteProjectType(type)"></i> -->
                                                            <mat-icon
                                                                #tooltip="matTooltip"
                                                                class="mat-icon-delete"
                                                                matTooltip="Delete"
                                                                [matTooltipPosition]="tooltip_position"
                                                                (click)="deleteProjectType(type)"
                                                                >delete</mat-icon
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 card_grid_body d-flex flex-row justify-content-between">
                                            <div class="activity-pack-description d-flex align-items-center">
                                                <p>{{ type.description }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
        <div class="no-type d-flex align-items-center justify-content-center w-100" *ngIf="defaultProjectTypesList.length <= 0">
            <h3>No Project Pack Type Available</h3>
        </div>
    </div>
</div>
